import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// KTK-221 — "Danger Zone" panel for the Agent V2 settings drawer.
//
// Visually distinct red treatment to set destructive actions off
// from the rest of the settings panel. Today it surfaces a single
// action: Delete this agent. Clicking opens a confirm dialog that
// requires the user to type the exact agent name before the final
// destructive button enables.
import { useState } from "react";
export function DangerZone({ agentName, onDelete }) {
    const [confirmOpen, setConfirmOpen] = useState(false);
    return (_jsxs("div", { className: "card", children: [_jsx("div", { className: "hint", children: "Removes the agent + DM channel + chat history. Stops the worker on its host. Cannot be undone." }), _jsx("div", { className: "dz", children: _jsx("button", { type: "button", className: "btn btn--danger", onClick: () => setConfirmOpen(true), children: "Delete agent" }) }), confirmOpen && (_jsx(DeleteConfirmDialog, { agentName: agentName, onCancel: () => setConfirmOpen(false), onConfirm: async () => {
                    await onDelete();
                    setConfirmOpen(false);
                } }))] }));
}
function DeleteConfirmDialog({ agentName, onCancel, onConfirm, }) {
    const [typed, setTyped] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const exact = typed === agentName;
    const handle = async () => {
        if (!exact || submitting)
            return;
        setSubmitting(true);
        setError(null);
        try {
            await onConfirm();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
            setSubmitting(false);
        }
    };
    return (_jsx("div", { onClick: onCancel, style: {
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "grid",
            placeItems: "center",
            zIndex: 200,
            padding: 24,
        }, children: _jsxs("div", { "data-agent-v2": "", "data-theme": "dark", onClick: (e) => e.stopPropagation(), style: {
                background: "var(--paper)",
                color: "var(--ink)",
                border: "1px solid color-mix(in oklab, var(--accent) 70%, #c0392b)",
                borderRadius: "var(--radius)",
                padding: 22,
                width: 460,
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 12,
                fontFamily: "var(--sans)",
            }, children: [_jsxs("h3", { style: {
                        margin: 0,
                        fontFamily: "var(--serif)",
                        fontSize: 18,
                        color: "color-mix(in oklab, var(--accent-ink) 80%, #c0392b 30%)",
                    }, children: ["Delete ", _jsx("em", { style: { color: "var(--ink)" }, children: agentName }), "?"] }), _jsxs("p", { style: {
                        margin: 0,
                        fontSize: "var(--fs-body)",
                        color: "var(--ink-2)",
                        lineHeight: 1.5,
                    }, children: ["This removes the agent, its DM channel, and the entire chat history. The runtime stops the worker on its host. ", _jsx("strong", { children: "This cannot be undone." })] }), _jsxs("p", { style: {
                        margin: 0,
                        fontSize: "var(--fs-body)",
                        color: "var(--ink-2)",
                    }, children: ["Type", " ", _jsx("code", { style: {
                                padding: "1px 6px",
                                borderRadius: "var(--radius-sm)",
                                background: "var(--paper-2)",
                                fontFamily: "var(--mono)",
                                fontSize: "var(--fs-code)",
                                color: "var(--ink)",
                            }, children: agentName }), " ", "to confirm:"] }), _jsx("input", { autoFocus: true, value: typed, onChange: (e) => setTyped(e.target.value), placeholder: agentName, style: {
                        padding: "8px 10px",
                        background: "var(--paper-2)",
                        color: "var(--ink)",
                        border: `1px solid ${exact ? "color-mix(in oklab, var(--accent) 70%, #c0392b)" : "var(--hairline)"}`,
                        borderRadius: "var(--radius-sm)",
                        fontFamily: "var(--mono)",
                        fontSize: "var(--fs-code)",
                        outline: "none",
                    } }), error && (_jsx("div", { style: {
                        fontSize: "var(--fs-meta)",
                        color: "color-mix(in oklab, var(--accent-ink) 80%, #c0392b 30%)",
                        padding: "6px 8px",
                        background: "var(--accent-soft)",
                        borderRadius: "var(--radius-sm)",
                    }, children: error })), _jsxs("div", { style: {
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 8,
                        marginTop: 4,
                    }, children: [_jsx("button", { type: "button", className: "btn btn--ghost", onClick: onCancel, children: "Cancel" }), _jsx("button", { type: "button", className: `btn btn--danger ${!exact || submitting ? "btn--disabled" : ""}`, onClick: () => void handle(), disabled: !exact || submitting, children: submitting ? "Deleting…" : "Delete agent" })] })] }) }));
}
//# sourceMappingURL=DangerZone.js.map